import { Popover, Transition } from '@headlessui/react';
import { Dispatch, Fragment, SetStateAction, useState } from 'react';
import { Switch } from '../switch';

export const NotificationsPopover = ({
  openPopover,
  setOpenPopover,
  from
}: {
  openPopover: boolean;
  setOpenPopover: Dispatch<SetStateAction<boolean>>;
  from: string;
}) => {
  const [enabledToggle, setEnabledToggle] = useState(true);
  const notifications = [
    {
      title: 'You have a new shared file',
      date: 'May 17, 2023',
      description:
        'User Jane.Smith@CompanyXYZ.com has shared file June_Results  with you. The file will appear automatically in your Dashboard.'
    },
    {
      title: 'You have a new shared file',
      date: 'March 18, 2023',
      description:
        'User Jane.Smith@CompanyXYZ.com has shared file June_Results  with you. The file will appear automatically in your Dashboard.'
    },
    {
      title: 'You have a new shared file',
      date: 'March 12, 2023',
      description:
        'User Jane.Smith@CompanyXYZ.com has shared file June_Results  with you. The file will appear automatically in your Dashboard.'
    },
    {
      title: 'You have a new shared file',
      date: 'March 18, 2023',
      description:
        'User Jane.Smith@CompanyXYZ.com has shared file June_Results  with you. The file will appear automatically in your Dashboard.'
    },
    {
      title: 'You have a new shared file',
      date: 'March 12, 2023',
      description:
        'User Jane.Smith@CompanyXYZ.com has shared file June_Results  with you. The file will appear automatically in your Dashboard.'
    },
    {
      title: 'You have a new shared file',
      date: 'March 12, 2023',
      description:
        'User Jane.Smith@CompanyXYZ.com has shared file June_Results  with you. The file will appear automatically in your Dashboard.'
    }
  ];
  const [notificationSelected, setNotificationSelected] = useState<any>({});
  const [notificationDetails, setNotificationDetails] = useState<boolean>(false);

  const handleNotificationSelected = (notification) => {
    setNotificationSelected(notification);
    setNotificationDetails(true);
  };

  const handleBackNotification = () => {
    setNotificationSelected(null);
    setNotificationDetails(false);
  };

  return (
    <Popover
      className={`${from === 'dashboard' ? 'mt-1' : ''} relative`}
      data-testid="notifications-popover">
      <>
        <Transition
          show={openPopover}
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1">
          <Popover.Panel className="absolute z-10 -translate-x-1 transform w-[581px] max-h-[485px] min-h-[485px] top-0 right-0 mr-0.5">
            <div className="overflow-hidden rounded-[20px] ring-1 ring-black ring-opacity-5 shadow-2xl divide-y-[1px] font-montserrat bg-white">
              <div className="flex justify-between mx-8 mt-4 mb-4">
                <div className="flex gap-3">
                  <img src="/icons/bell-notification.svg" alt="Computer icon" />
                  <span className="text-[#364152] text-sm font-semibold">Notifications</span>
                </div>
                <div>
                  <img
                    src="/icons/cancel.svg"
                    alt="Computer icon"
                    className="cursor-pointer"
                    onClick={() => setOpenPopover(false)}
                  />
                </div>
              </div>

              <div className="flex justify-between pt-3.5 px-7 mb-7">
                <span className="font-semibold text-xs text-[#788AA6] capitalize">
                  Mark all as Read
                </span>
                <Switch
                  enabled={enabledToggle}
                  setEnabled={setEnabledToggle}
                  rightLabel="Show Only Unread"
                  type="one-label-notification"
                />
              </div>

              <div className="flex flex-col mx-5 divide-y-[1px] overflow-y-auto max-h-[328px] min-h-[328px] pr-3">
                {!notificationDetails &&
                  notifications.map((notification, index) => (
                    <div
                      className="flex items-center gap-3.5 mx-3.5"
                      data-testid={`notification-item-${index}`}
                      key={index}>
                      <div>
                        <div className="w-2 h-2 bg-[#E7811D] rounded-full flex items-center justify-center"></div>
                      </div>
                      <div key={index} className="py-2.5 flex flex-col">
                        <span className="text-[#364152] font-semibold text-sm">
                          {notification.title}
                        </span>
                        <span className="text-[#364152] text-[11px] font-light">
                          {notification.date}
                        </span>
                        <span className="line-clamp-1 text-xs text-[#364152]">
                          {notification.description}
                        </span>
                      </div>
                      <div>
                        <img
                          src="/icons/right-arrow-notification.svg"
                          alt="Computer icon"
                          className="cursor-pointer w-4"
                          onClick={() => handleNotificationSelected(notification)}
                        />
                      </div>
                    </div>
                  ))}
                {notificationDetails && (
                  <div className="flex items-start gap-6 mx-3.5" data-testid="notification-details">
                    <div className="mt-5">
                      <img
                        src="/icons/left-arrow-notification.svg"
                        alt="Computer icon"
                        className="cursor-pointer w-4"
                        onClick={handleBackNotification}
                        data-testid="back-button"
                      />
                    </div>
                    <div className="py-2.5 flex flex-col">
                      <span className="text-[#364152] font-semibold text-sm">
                        {notificationSelected.title}
                      </span>
                      <span className="text-[#364152] text-[11px] font-light">
                        {notificationSelected.date}
                      </span>
                      <span className="text-xs text-[#364152] leading-6">
                        {notificationSelected.description}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Popover.Panel>
        </Transition>
      </>
    </Popover>
  );
};
